export default __webpack_public_path__ + "static/media/img-0774-sweden-half-face.32da0647.png";